import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    anotherCorporateOfficer: 'Another unlisted corporate officer',
    anotherCorporateOfficerDescription:
      'Select this option if your name does not appear in the list.',
    clickHere: 'Click here',
    ctaContinue: 'Continue',
    notCorporateOfficer:
      'You are not a corporate officer, but have a signed power of attorney from one of them?',
    title: 'Who are you?',
  },
  fr: {
    anotherCorporateOfficer: 'Un·e autre dirigeant·e',
    anotherCorporateOfficerDescription:
      'Sélectionnez cette option si votre nom n’apparaît pas dans la liste.',
    clickHere: 'Cliquez ici',
    ctaContinue: 'Continuer',
    notCorporateOfficer:
      'Vous n’êtes pas un·e dirigeant·e de la société, mais vous avez une procuration signée de l’un·e d’entre eux\u00A0?',
    title: 'Qui êtes-vous\u00A0?',
  },
} as const);
